import React from 'react';
import {
  AuthProvider,
  DictionariesContextProvider,
  AppLayoutContextProvider,
  AppChatContextProvider,
} from '@monument/core';
import { BrowserRouter as Router } from 'react-router-dom';

export const InitializeApp: React.FC = ({ children }) => {
  return (
    <AuthProvider>
      <Router basename={process.env.PUBLIC_URL}>
        <AppLayoutContextProvider>
          <AppChatContextProvider>
            <DictionariesContextProvider>{children}</DictionariesContextProvider>
          </AppChatContextProvider>
        </AppLayoutContextProvider>
      </Router>
    </AuthProvider>
  );
};
